<gs-dialog
  [(visible)]="visible"
  [header]="'Enjoying GratSync?'"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [innerWidth]="460"
  [styleClass]="'g2-review-dialog'"
>
  <ng-template pTemplate="gsDialogContent">
    <div class="g2-review-body">
      <i class="pi pi-star-fill g2-review-icon"></i>
      <p class="g2-review-text">
        Got a minute? Share your experience with GratSync on G2. Your review helps
        other teams discover us — and helps us keep improving.
      </p>

      <!-- Opt-out is a deliberate checkbox, not a button: prevents an accidental
           permanent dismiss. Combined with "Not now" below. -->
      <div class="g2-review-optout">
        <p-checkbox
          [(ngModel)]="dontShowAgain"
          [binary]="true"
          inputId="g2DontShowAgain"
        ></p-checkbox>
        <label for="g2DontShowAgain">Don't show me this again</label>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="gsDialogFooter">
    <div class="g2-review-actions">
      <button
        type="button"
        pButton
        class="edit g2-review-primary"
        icon="pi pi-star"
        label="Leave a review"
        (click)="leaveReview()"
      ></button>
      <button
        type="button"
        pButton
        class="p-button-outlined g2-review-secondary"
        label="Not now"
        (click)="notNow()"
      ></button>
    </div>
  </ng-template>
</gs-dialog>

<!-- G2 embed (PDP-5): the seamless G2 review form in an iframe. Reuses gs-dialog. -->
<gs-dialog
  [(visible)]="embedVisible"
  [header]="'Leave a G2 review'"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [innerWidth]="780"
  [styleClass]="'g2-embed-dialog'"
  (onClose)="closeEmbed()"
>
  <ng-template pTemplate="gsDialogContent">
    <div class="g2-embed-body">
      <div *ngIf="embedLoading" class="g2-embed-status">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading the review form…</span>
      </div>

      <div *ngIf="embedError" class="g2-embed-status g2-embed-error">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ embedError }}</span>
      </div>

      <div *ngIf="embedInfo" class="g2-embed-status g2-embed-info">
        <i class="pi pi-check-circle"></i>
        <span>{{ embedInfo }}</span>
      </div>

      <ng-container *ngIf="embedUrl && !embedError && !embedInfo">
        <iframe
          [src]="embedUrl | safe"
          class="g2-embed-iframe"
          title="G2 review"
        ></iframe>
        <p class="g2-embed-fallback">
          Trouble loading?
          <a [href]="embedUrl" target="_blank" rel="noopener noreferrer">Open in a new tab</a>.
        </p>
      </ng-container>
    </div>
  </ng-template>

  <!-- Suppress gs-dialog's default edit/apply footer; the header X closes it. -->
  <ng-template pTemplate="gsDialogFooter"><span></span></ng-template>
</gs-dialog>
